module.exports = __webpack_public_path__ + "static/img_4969-15ef8bcaa6c8d36fd3eccd1f912ee8ab.webp";